// @ts-nocheck
import React from "react";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import SinapThemev2 from '../styles/SinapThemev2';
import Box from '@mui/material/Box';
import Grid from "@mui/material/Grid";
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function CircularProgressWithLabel({ value }) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress size={50} thickness={4} variant="determinate" value={value} />
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="body2" color="text.primary">
                    {Math.round(value / 10)}
                </Typography>
            </Box>
        </Box>
    );
}

export const RedireccionView = ({ href, titulo, subtitulo, icono }) => {
    const [progress, setProgress] = React.useState(100);
    const matches = useMediaQuery('(max-width:600px)');

    React.useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prev) => (prev <= 0 ? 0 : prev - 10));
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    React.useEffect(() => {
        if (progress === 0) {
            window.location.href = href;
        }
    }, [progress]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={SinapThemev2}>
                <Box
                    sx={{
                        minHeight: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'background.default',
                        px: 2,
                    }}
                >
                    <Grid
                        container
                        spacing={2}
                        direction="column"
                        alignItems="center"
                        maxWidth="sm"
                    >
                        <Grid item>{icono}</Grid>

                        <Grid item>
                            <Typography
                                align="center"
                                variant={matches ? "h5" : "h4"}
                                fontWeight={500}
                            >
                                {titulo}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Typography align="center" variant="body2" color="text.secondary">
                                {subtitulo}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Typography variant="body1" align="center">
                                Redireccionando en...
                            </Typography>
                        </Grid>

                        <Grid item>
                            <CircularProgressWithLabel value={progress} />
                        </Grid>
                    </Grid>
                </Box>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default function RedirectSuccess() {
    const matches = useMediaQuery('(max-width:600px)');

    return (
        <RedireccionView
            href={window.location.origin + '/'}
            titulo={"Datos guardados correctamente"}
            subtitulo={
                "Su cuenta está pendiente de confirmación. Recibirá un mail cuando se active."
            }
            icono={
                <CheckCircleOutlineIcon
                    sx={{
                        fontSize: matches ? 40 : 60,
                        color: 'text.primary'
                    }}
                />
            }
        />
    );
}
